import { Entity } from '@api/api/entity-schema';
import { formatTicker } from '@api/mappers/formatTicker';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';

import styles from './CompanyCell.module.scss';

interface CompanyCellProps {
  entity: Entity;
}

export const CompanyCell = ({ entity }: CompanyCellProps) => {
  return (
    <div className={styles.root}>
      <AssetLogoContainer entity={entity} size={32} />
      <div className={styles.flexColumn}>
        <div className={styles.titleLabel}>
          {entity.name_short || entity.name}
        </div>
        <div className={styles.subtitleLabel}>{formatTicker(entity)}</div>
      </div>
    </div>
  );
};
